import axios from "axios";
import Cookies from "universal-cookie";

const base_url = axios.create({
  baseURL: "https://s-plus.ir/api",
});

const cookies = new Cookies();
const token = cookies.get("api_key");
if (token) {
  base_url.defaults.headers["Authorization"] = token;
}
// else {
//   base_url.defaults.headers["Authorization"] = "";
// }
base_url.defaults.headers["Content-Type"] = "application/json";
export { base_url };
